<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <div class="backBox">
      <jd-back @back="returnBack()" :title="['互动广场']" :subTitle="activityData.name" style="padding-bottom: 0"></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <jd-tip style="margin-bottom: 10px">云短信CRM ：订购到期时间
          {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。</jd-tip>
        <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="150px">
          <!-- 基本信息 -->
          <informationForm @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember" :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime" :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime" :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected" ref="informationForm" v-model="ruleForm" :isEdit="false"
            :isNeedCusType="true" :cusType.sync="ruleDTO.cusType" :disabled="activityData.isStart"
            :localStepNum="localStepNum" :activityId="89" :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>

          <jd-title label="答题设置"></jd-title>
          <div class="mt20">
            <el-form-item label="优惠券设置：" required>
              <div>
                <jd-button @click="addCoupon" style="margin-bottom:10px" type="blue">添加优惠券({{ couponList.length
                  }}/10)</jd-button>
                <jd-table :tableData="couponList" style="width: 1100px">
                  <el-table-column label="奖品类型" width="200">
                    <template>
                      优惠券
                    </template>
                  </el-table-column>
                  <el-table-column prop="couponNum" label="奖品价值" width="200">
                    <template slot-scope="scope">
                      {{ scope.row.price }}元
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="price" label="奖品图片" width="100">
                    <template slot-scope="scope">
                      <img :src="scope.row.price" alt="" style="margin-top: 10px;width: 56px;height: 56px;">
                    </template>
                  </el-table-column> -->
                  <el-table-column prop="title" label="奖品名称" width="220">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.title" maxlength="12" show-word-limit
                        style="width: 180px"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalAmount" label="奖品数量" width="200">
                    <template slot="header">
                      <span style="color:red;">*</span>
                      <span>
                        奖品数量
                      </span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.totalAmount"
                        @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1, 999999)" class="inputcount"
                        style="width: 120px" placeholder="请输入" @change="(val) => {
                          scope.row.dailyLimitType = 0
                          scope.row.dailyLimit = null
                          scope.row.idleLimit = null
                          scope.row.busyLimit = null
                        }" :disabled="!canSelectPrize(scope.row) && !scope.row.minNum"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="200">
                    <template slot-scope="scope">
                      <dailyLimitConfig :row="scope.row" :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="兑换所需积分" width="200">
                    <template slot="header">
                      <span style="color:red;">*</span>
                      <span>
                        兑换所需积分
                      </span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.needPointAmount"
                        @input="scope.row.needPointAmount = getNumberData(1, $event, 0, 1, 999999)"
                        :disabled="!canSelectPrize(scope.row)" placeholder="请输入" style="width: 120px"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="personExchangeLimit" label="每人兑换限制（总）" width="200">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.personExchangeLimit"
                        @input="scope.row.personExchangeLimit = getNumberData(1, $event, 0, 1, 999999)"
                        :disabled="!canSelectPrize(scope.row)" placeholder="请输入" style="width: 120px"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="领取时间" width="200">
                    <template slot-scope="scope">
                      <span v-if="scope.row.takeBeginTime && scope.row.takeEndTime">
                        {{ scope.row.takeBeginTime }}至{{ scope.row.takeEndTime }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200" fixed="right">
                    <template slot-scope="scope">
                      <jd-button :disabled="backgroundOpacity || !canSelectPrize(scope.row)" type="blueText"
                        @click="handleEdit(scope.row,scope.$index)">选择奖品</jd-button>
                      <jd-button v-if="scope.$index != 0" type="blueText" :disabled="backgroundOpacity || !canSelectPrize(scope.row)"
                        @click="handleDelete(scope.$index)">删除</jd-button>
                      <jd-button type="blueText" v-if="!backgroundOpacity && !canSelectPrize(scope.row)"
                        @click="itemAddNum('couponList', scope.$index)">增加奖品数量</jd-button>
                    </template>
                  </el-table-column>
                </jd-table>
              </div>
            </el-form-item>
            <el-form-item label="兑换次数限制：">
              <div style="display: flex; align-items: center;color: #333;">
                活动期间每人每天最多可兑换
                <el-input v-model="ruleDTO.dailyLimit"
                  @input="(e) => ruleDTO.dailyLimit = validSe(e,99999)" placeholder="请输入"
                  style="width: 100px;margin: 0 4px;"></el-input>
                次，累计每人最多可兑换
                <el-input v-model="ruleDTO.totalLimit"
                  @input="(e) => ruleDTO.totalLimit = validSe(e,99999)" placeholder="请输入"
                  style="width: 100px;margin: 0 4px;"></el-input>
                次
              </div>
            </el-form-item>
          </div>

          <!-- 活动页设置 -->
          <activityPageSettings style="min-height: 620px;" :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true" :giftList="giftList" :templateId="templateId" :isShowDesignNumber="false" :isShowMoreSet="true"
            previewKey="url" templatekey="imageUrl" :widthNumber="750" :heightNumber="1624" :isCustomPreview="true"
            :downloadTemplateUrl="'https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/积分兑换优惠券.psd'"
            designSpecificationsUrl="https://cdn-image.yucrm.cn//hd/images/13315956_fc0b55ee41f64f9b8cd72456b3c5aa2d.png" themeTitle="主题"
            :defaultRgb="currrentRgb" v-model="customerPaperwork" @selectTemplate="selectTemplate">
            <template #customPreview>
              <pointPreview ref="pointPreview" :couponList="couponList" :ruleForm="customerPaperwork" :cusTemplateJSON="ruleDTO.cusTemplateJSON" />
            </template>
            <template #otherSet>
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <el-form-item label="按钮背景：" label-width="120px" required>
                    <div class="common-flex1">
                      <!-- :before-upload="(file) => beforeUploadCommon(file, 580, 94)" -->
                      <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :before-upload="(file) => beforeUploadCommon(file, 580, 94)" 
                        :disabled="backgroundOpacity" :show-file-list="false" :on-success="(res) => handleUploadCommonSuccess(res, 'url2')
                          ">
                        <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button>
                      </el-upload>
                      <jd-button type="blueText" style="margin-left: 16px" @click="
                        customerPaperwork.url2 = templateObj.url2
                        " :disabled="backgroundOpacity">重置</jd-button>
                      <span style="color: #999;margin-left: 16px;">
                        尺寸：490px*94px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="文案颜色：" label-width="120px" required>
                    <div class="common-flex1">
                      <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.rgb2"
                        size="small"></el-color-picker>
                      <jd-button type="blueText" style="margin-left: 16px" @click="
                        customerPaperwork.rgb2 = templateObj.rgb2
                        " :disabled="backgroundOpacity">重置</jd-button>
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>

              <el-form-item label="用户卡片背景色:">
                <div class="common-flex1">
                  <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.cardBgColor"
                    size="small"></el-color-picker>
                  <jd-button type="blueText" style="margin-left: 16px" @click="
                    customerPaperwork.cardBgColor = templateObj.cardBgColor
                    " :disabled="backgroundOpacity">重置</jd-button>
                </div>
              </el-form-item>
              <el-form-item label="用户信息文案颜色:">
                <div class="common-flex1">
                  <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.cardTextColor"
                    size="small"></el-color-picker>
                  <jd-button type="blueText" style="margin-left: 16px" @click="
                    customerPaperwork.cardTextColor = templateObj.cardTextColor
                    " :disabled="backgroundOpacity">重置</jd-button>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <jd-title label="展示店铺"></jd-title>
          <div class="mt20">
            <el-form-item label="小程序店铺信息：" label-width="150px">
              <el-radio-group v-model="customerPaperwork.shopNameType">
                <el-radio :label="0">统一显示配置店铺</el-radio>
                <el-radio :label="2">不显示店铺信息</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <exposureList v-model="itemListFor" :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
            :isLimit="true" :limitNum="limitNum" :isEdit="isCreated" :multiShopSkuType.sync="multiShopSkuType"
            :multiShopGoods="multiShopGoods" :skuBelongVenderId="ruleForm.skuBelongVenderId" />

          <sharFrom v-model="ruleForm" :sharePic="sharePic" />

          <activityRules v-model="ruleForm.ruleDescription" :isForceRemind.sync="ruleDTO.isForceRemind"
            :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition" :activityData="activityData"
            :valueRow="valueRow" @generateRule="generateRule" />
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button v-if="localStepNum != 0" style="margin-right: 8px" @click="clickLocalStep()">{{ backgroundOpacity ?
        "返回列表" : "返回上一步" }}</jd-button>
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick>保存设置</jd-button>
      </template>
    </div>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 选择优惠券 -->
    <selectPrize v-model="dialogPrize" @closePrize="closePrize" :echoDate="echoDate"></selectPrize>
    <!-- 保存设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>
        <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="blue" style="margin-left: 8px" v-loading="saveLoading">确
          定</jd-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectPrize from "@/views/interactiveMarketing/activity/select_prize.vue";
import { useUpdateBasicInformation,setBasicInformation } from "./components/commDataHook/usePointsRedemptionCoupon.js";
import { useValidateBasicInformation } from "./components/commDataHook/useBasicInformation.js";
import informationForm from "./components/informationForm.vue";
import { useJdCrm } from "./components/commDataHook/useCommReq.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import activityPageSettings from "./components/activityPageSettings.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue"
import exposureList from "./components/exposureList.vue";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import addPrizeNum from "./components/add-prize-num.vue";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import pointPreview from './components/pointPreview.vue';
import { exchangeCouponSaveOrUpdate, exchangeCouponDetail } from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";

export default {
  components: {
    informationForm,
    activityPageSettings,
    sharFrom,
    activityRules,
    exposureList,
    dailyLimitConfig,
    selectPrize,
    addPrizeNum,
    pointPreview,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => { },
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echoDate: null,
      checked: false,
      isShowAddNum: false,
      toAddIndex: null,
      toAddBelong: "",
      toAddItem: {},
      prizeIndex: null,
      dialogPrize: false,
      multiShopGoods: [],
      multiShopSkuType: 0,
      isCreated: false,
      limitNum: 20,
      itemListFor: [],
      placementPosition: [],
      isKeyActivity: 0,
      giftList: [],
      couponList: [
        {
          prizeType: 1,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          orderPaymentLimit: null,
          takeBeginTime: "",
          takeEndTime: "",
          needPointAmount: null,
          personExchangeLimit: null,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          singleAmount: "",
          discount: "",
          dailyLimitType: 0,
          dailyLimit: null,
          idleLimit: null,
          busyLimit: null,
        }
      ],
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      saveLoading: false,
      loading: false,
      peopleSelected: [],
      levelList: [],
      activityStartTime: "",
      activityEndTime: "",
      actMember: "1",
      isDraft: false,
      joinBlackList: false,
      customerPaperwork: {
        title: "积分兑换优惠券", //主题
        desc: "", //描述
        titleColor: "", // 标题颜色
        shopNameType: 0, //小程序店铺信息类型
        url: "", // 小程序店铺信息
        url2: "", // 按钮背景
        rgb2: "", // 按钮文案颜色
        cardTextColor: "#E7D9B4",
        cardBgColor: "#1E1E1C", // 用户卡片背景色
        crowdTipMainText: "", // 人群提示主文案
        crowdTipSubText: "", // 人群提示副文案
      },
      designUrl: "",
      jdCrm: {
        endTime: "",
      },
      sharePic: "https://cdn-image.yucrm.cn//hd/images/13315956_b07deef9245d4982b9ef13a008f50b80.png", // 初始图
      ruleDTO: {
        plusObject: 0,
        openCardStartTime: "",
        openCardEndTime: "",
        cusType: 0, //新老客类型
        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        dailyLimit: null, // 活动期间每人每天最多可兑换xx次
        totalLimit: null, // 累计每人最多可兑换xx次
        cusTemplateJSON: "",

        isForceRemind: false, // 是否强制提醒
      },
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
        shareTitle: "我分享了一个积分兑换优惠券活动给你，快来看看吧！", // 分享标题
        shareIntroduce: "我在京东有新发现，绝对适合你，速来围观～", // 分享简介
        sharePic: "https://cdn-image.yucrm.cn//hd/images/13315956_b07deef9245d4982b9ef13a008f50b80.png", // 分享图片
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteEndDay: "",
        lastOrderCompleteStartDay: "",
        lastOrderCompleteStartTime: "",
        lastOrderCompleteEndTime: "",

        priceType: 0,
        isExposureItem: 0,
        itemList: [],

        ruleDescription: "",
        exposureSwitch: false,
        skuBelongVenderId: "",
      },
      templateObj: {},
      templateId: null,
      templateJson: {
        templateUItype: "",
      },
      peopleSelected: [],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
    }
  },
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    useJdCrm(this);
    this.buriedPoint(1, "积分兑换优惠券", "互动管理", "互动活动");
  },
  computed: {
    venderType() {
      return this.$store.getters.loginUserInfo.venderType
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    canSelectPrize() {
      return (row) => {
        let isCanSelect = false;
        isCanSelect = (this.activityData.isStart && !row.id) || !this.activityData.isStart
        return isCanSelect
      }
    }
  },
  methods: {
    // 返回上一步
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.$emit("returnBack");
      // this.localStepNum = 0;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
        //输入大于0的正整数
    validSe(data,max) {
      let filtered = data.replace(/[^\d]/g, "");
      if (Number(filtered) < 1) {
        filtered = "";
      }
      if (max && Number(filtered) > max) {
        filtered = max;
      }
      return filtered;
    },
    //判断尺寸方法 默认200*200
		imgchecked(file, width = 200, height = 200) {
			let _this = this;
			return new Promise((resolve, reject) => {
				let image = new Image();
				let _URL = window.URL || window.webkitURL;
				image.onload = function () {
					const valid = image.width == width && image.height == height;
					file.isFlag = valid;

					console.log(valid);
					if (valid) {
						console.log("Image loaded");
						resolve();
					} else {
						_this.$message.info("图片尺寸不符合要求，请重新上传");
						reject();
					}
				};
				image.src = _URL.createObjectURL(file);
			});
		},
    // 校验
		async beforeUploadCommon(file, width, height) {
			const status = await this.imgchecked(file, width, height);
			if (!status) {
				return false;
			}
			let type1 = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
			let sorts = [".png", ".jpg"];
			if (sorts.indexOf(type1) < 0) {
				this.$message.warning("所选文件格式不符，请重新选择");
				return false;
			}
		},
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    async handleDialogCloseAnoth() {
      let obj = {
        pointActivityPrizeDTOList: []
      };
      obj.subType = 89;
      obj = this.deepClone(this.ruleForm);
      obj.isKeyActivity = this.isKeyActivity;
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.placementPosition = this.placementPosition.join(',');
      obj.ruleDTO = this.deepClone(this.ruleDTO);
      obj.ruleDTO.openCardStartTime = this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime = this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";

      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow
      obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType
      obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay
      obj.ruleDTO.isForceRemind = this.ruleDTO.isForceRemind
      obj.ruleDTO.shareTitle = this.ruleForm.shareTitle
      obj.ruleDTO.shareIntroduce = this.ruleForm.shareIntroduce
      obj.ruleDTO.sharePic = this.ruleForm.sharePic

      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel = this.ruleForm.partner && this.ruleForm.partner.length ? this.ruleForm.partner.join(",") : "";
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      obj.ruleDTO.orderCompleteLimitCount = this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment = this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay = this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }

      obj.pointActivityPrizeDTOList = this.couponList
      obj.isExposureItem = this.ruleForm.exposureSwitch == false ? 0 : 1
      obj.itemList = this.itemListFor; //曝光商品集合

      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          const params = useUpdateBasicInformation(obj, obj.pointActivityPrizeDTOList, this);
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }else{
          if (this.isDraft) {
            obj.status = 5;
            obj.pointActivityPrizeDTOList = obj.pointActivityPrizeDTOList.filter(item => item.assetsId)
          }
          if (this.valueRow) {
            obj.pointActivityId = this.valueRow.id;
            obj.id = this.valueRow.id;
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
            // 草稿箱保存正式活动删除id
            // if (!obj.status) {
            //   delete obj.id;
            // }
          }
          if(this.activityData.isCopy){
            delete obj.id
            delete obj.pointActivityId;
          }
          exchangeCouponSaveOrUpdate(obj).then((res) => {
            this.saveLoading = false;
            if (res.code == 1) {
              if (this.isDraft) {
                this.$message.success("保存成功！");
                this.$emit("returnBack", true);
              } else {
                this.$message.success(res.message);
                this.$router.push({
                  name: "throw2",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              }
            } else {
              this.$message.error(res.message);
            }
          }).catch(() => {
            this.saveLoading = false;
          })
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    resetForm(){
      // 公共校验
      if (!useValidateBasicInformation(this)) {
        return;
      }

      let isPass = true;
      this.couponList.forEach(item => {
        if(!item.title){
          isPass = false;
        }
        if(!item.assetsId){
          isPass = false;
        }
        if(!item.totalAmount){
          isPass = false;
        }
        if(!item.needPointAmount){
          isPass = false;
        }
      })

      if(!isPass){
        this.$message.error("请填写完整优惠券信息");
        return;
      }
      if(!this.ruleForm.sharePic){
        this.$message.warning("请分享图片");
        return;
      }
      if(!this.ruleForm.shareTitle){
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      if(!this.ruleForm.shareIntroduce){
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if(!this.ruleForm.ruleDescription){
        this.$message.warning("请输入规则内容");
        return;
      }

      if(this.placementPosition.length == 0){
        this.$message.warning("请选择活动投放位置");
        return;
      }

      this.joinBlackList = true;
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    closePrize(val, params) {
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        console.log("params=====>", params);
        this.couponList[this.prizeIndex] = {
            ...this.couponList[this.prizeIndex],
            prizeType: 1,
            couponType: params.couponType,
            title: params.name,
            singleAmount: 1,
            price: params.discount,
            batchKey: params.putkey || params.couponIdOrPutKey,
            validateDay: params.addDays,
            bindType: params.couponFrom,
            assetsId: params.assetsId,
            logo: params.logo?params.logo:"",
            quota: params.quota,
            takeBeginTime: params.takeBeginTime,
            takeEndTime: params.takeEndTime,
            prizeGoShop: params.prizeGoShop
        }
      }
      this.couponList = JSON.parse(JSON.stringify(this.couponList));
      this.dialogPrize = false;
    },
    handleEdit(row,index) {
      this.prizeIndex = index;
      this.echoDate = {...row};
      this.dialogPrize = true;
    },
        // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },
    // 上传
    handleUploadCommonSuccess(res, key) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.customerPaperwork[key] = res.data;
      }
    },
    handleDelete(index) {
      this.couponList.splice(index, 1);
    },
    addCoupon() {
      if (this.couponList.length >= 10) {
        this.$message({
          message: "优惠券数量不能超过10个",
          type: "warning",
        });
        return;
      }
      this.couponList.push({
        prizeType: 1,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        orderPaymentLimit: null,
        takeBeginTime: "",
        takeEndTime: "",
        needPointAmount: null,
        personExchangeLimit: null,
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        singleAmount: "",
        discount: "",
        dailyLimitType: 0,
        dailyLimit: null,
        idleLimit: null,
        busyLimit: null,
      })
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    generateRule() {
      const {firstTextStr,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDTO,this.actMember,false);
      let secondTextStr = "\n二、【活动参与规则】";
      let fourthTextStr = `\n\n三、【注意事项】\n1.${ precautions }`
      let text1 = `\n1.每人每天限兑换次数：${this.ruleDTO.dailyLimit?this.ruleDTO.dailyLimit+"次":"不限"};`
      let text2 = `\n2.活每日总兑换次数限制：${this.ruleDTO.totalLimit?this.ruleDTO.totalLimit+"次":"不限"};`
      let text3 = `\n3.每个优惠券每日最多可领取一次；`
      this.ruleForm.ruleDescription = firstTextStr + secondTextStr + text1 + text2 + text3 + fourthTextStr;
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },

    //会员等级
    getLevel() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
      }
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {
          this.loading = false;
        });
    },

    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        exchangeCouponDetail({id:this.valueRow.id})
          .then((res) => {
            setBasicInformation(res.data, this);
            this.loading = false;
            this.getPolite();
          })
          .catch((res) => { });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    initCustomizeData(row) {
      this.customerPaperwork.url = row.url || "";
      this.customerPaperwork.url2 = row.url2 || "";
      this.customerPaperwork.titleColor = row.rgb || "";
      this.customerPaperwork.rgb2 = row.rgb2 || "";
      const configJson = row.configJson ? JSON.parse(row.configJson) : {};
      // 遍历 configJson，若 customerPaperwork 存在相同 key 则赋值
      Object.keys(configJson).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.customerPaperwork, key)) {
          this.customerPaperwork[key] = configJson[key];
        }
      });
      this.resetRgb(row, configJson);
    },
    resetRgb(row, configJson) {
      this.currrentRgb = row.rgb || "";
      this.templateObj = {
        ...row,
        ...configJson,
      }
    },
    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
            return {
              ...item,
              days: item.activityStartTime
                ? this.getDaysBetween(
                  item.activityStartTime,
                  item.activityEndTime
                )
                : "",
            };
          })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        const configJson = this.templateObj.configJson
          ? JSON.parse(this.templateObj.configJson)
          : {};
        this.templateId = this.templateId;
        this.resetRgb(this.templateObj, configJson);
      }
      this.pageData.total = data.total * 1;
    }
  },
}
</script>

<style lang="scss" scoped>
.common-flex1 {
  display: flex;
  align-items: center;
}

.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }

  .showTip {
    color: red;
    font-size: 14px;
  }

  .openTip {
    margin-left: 8px;
    color: #333333;
  }

  .rule_box {
    background-color: #f7f8fa;
    padding: 16px 16px 1px;
    border-radius: 4px;
    font-size: 14px;
  }

  .upload-box {
    width: 485px;
    padding: 20px 20px 1px;
    background: #f4f6fa;
    border-radius: 4px;
  }

  .textStyle {
    color: #333333;
  }

  .question-style {
    margin-left: 12px;
    display: flex;
    align-items: center;
    color: #3159ff;
  }
}

.ml8 {
  margin-left: 8px;
}

.mlr8 {
  margin: 0 8px;
}

.ml16 {
  margin-left: 16px;
}

.w100 {
  width: 100px;
}

.w120 {
  width: 120px;
}

.w80 {
  width: 80px;
}

.w160 {
  width: 160px;
}

.w200 {
  width: 200px;
}

.w60 {
  width: 60px;
}

.flex-c {
  display: flex;
  flex-direction: column;
}

.flex-r {
  display: flex;
  align-items: center;
}

/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}

.draggable-box {
  margin-top: 10px;
  background: rgba(38, 112, 251, 0.06);
  padding: 10px;
  user-select: none;
  /* 标准语法 */
  -webkit-user-select: none;
  /* Chrome, Safari, Opera */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}

.design {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99999;

  .design-box {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 760px;

    .design-close {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      font-size: 25px;
      color: #979aa0;
      z-index: 5000;
    }

    .design-close:hover {
      color: #2768ff;
    }

    .design-url {
      width: 100%;
      height: auto;
    }
  }
}
</style>